import { gql } from '@apollo/client';

export const READ_LANDLORD = gql`
  query ReadLandlord($input: ReadLandlordInput!) {
    readLandlord(input: $input) {
      uid
      name
    }
  }
`;
